package com.kinoshazam

import com.kinoshazam.model.AppLanguage
import kotlinx.browser.window

actual fun changeLanguage(language: AppLanguage) {
    // Apply before Compose remounts so Locale.current / resource environment
    // see the new language on the next stringResource() call.
    window.asDynamic().__customLocale = language.locale.replace('_', '-')
}
